import { Controller, useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { FormGroup, Label } from 'reactstrap';

import RequiredStarLabel from '../../../../components/common/requiredStarLabel';
import EntitySelect from '../../../../components/entitySelect/EntitySelect';
import FormGroupNote from '../../../../components/form/FormGroupNote';
import { productApi } from '../../../../helpers/api/productApi';

export default function RelayProductSelect({ isRequired, isDisabled }) {
  const { t } = useTranslation();
  const {
    control,
    formState: { errors }
  } = useFormContext();

  const inputName = 'relayId';

  return (
    <FormGroup>
      <Label htmlFor={inputName}>
        {t('Relay')} {isRequired && <RequiredStarLabel />}
      </Label>
      <Controller
        name={inputName}
        control={control}
        render={({ field }) => (
          <EntitySelect
            name={inputName}
            displayName={t('Relay')}
            fieldValue={field.value}
            onChange={field.onChange}
            placeholder="Not specified"
            fetchDataFunction={() => {
              return productApi
                .getProducts({
                  categorySlug: 'relay'
                })
                .then((res) => ({
                  data: res?.data?.items || []
                }));
            }}
            isDisabled={isDisabled}
          />
        )}
      />
      {errors.relayId && (
        <FormGroupNote type="warning">{errors.relayId.message}</FormGroupNote>
      )}
    </FormGroup>
  );
}
